const createTranslationsRequests = (client) => ({
    listTranslations: async (params) => {
        const { data, meta, links } = await client.api.get("translations", {
            params: params,
        });
        return { data, meta, links };
    },
    saveTranslation: async (payload) => {
        const { data } = await client.api.post("translations", payload);
        return { data };
    },
    populateTranslations: async (payload) => {
        const { data } = await client.api.request({
            type: "translations",
            method: "POST",
            url: "/translations/populate",
            body: payload,
        });
        return { data };
    },
    importTranslations: async (payload) => {
        const { data } = await client.api.request({
            type: "translations",
            method: "POST",
            url: "/translations/import",
            body: payload,
        });
        return { data };
    },
    translateAllTranslations: async (payload) => {
        const { data } = await client.api.request({
            type: "translations",
            method: "POST",
            url: "/translations/translate_all",
            body: payload,
        });
        return { data };
    },
});
export default createTranslationsRequests;
//# sourceMappingURL=index.js.map